import { render, staticRenderFns } from "./AgeGroupChart.vue?vue&type=template&id=0d72c134&"
import script from "./AgeGroupChart.vue?vue&type=script&lang=js&"
export * from "./AgeGroupChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports